module.exports = __webpack_public_path__ + "static/media/logo-mercadopago.6fa883d4.png";